import CirclePercentage from '../CirclePercentage';

export default function Percentage(params) {
    const percentageCell = document.createElement('div');
    percentageCell.classList.add('w5-percentage-cell');

    if (!params.value && params.value !== 0) return percentageCell;

    const circle = CirclePercentage(params.value, params);

    percentageCell.appendChild(circle);
    return percentageCell;
}
